<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <div>
      <Snackbar :snackbar="snackbar" :text="text" :timeout="timeout"></Snackbar>
      <LoadingComponent v-if="process.loading"></LoadingComponent>

      <v-row
        class="mt-3"
        :class="$vuetify.breakpoint.name !== 'xs' ? 'px-3' : 'pr-0 pl-3'"
        v-if="!process.loading"
      >
        <v-col cols="12">
          <v-card class="border-radius box-shadow pa-1">
            <v-row>
              <v-col cols="12" class="py-0">
                <v-card-text>
                  <div class="color-first title font-weight-bold title mt-3">
                    Katalog
                  </div>

                  <v-row class="pt-5">
                    <v-col cols="12" md="3">
                      <v-select
                        dense
                        :disabled="process.run"
                        outlined
                        :items="list.jenis"
                        item-text="nama_jenis_barang"
                        item-value="id"
                        v-model="filter.jenis"
                        v-on:change="getList()"
                        label="Jenis"
                        color="#0299B7"
                        hide-details
                      >
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        dense
                        :disabled="process.run"
                        outlined
                        :items="list.lab"
                        item-text="nama_laboratorium"
                        item-value="id"
                        v-model="filter.lab"
                        v-on:change="getList()"
                        label="Laboratorium"
                        color="#0299B7"
                        hide-details
                      >
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        dense
                        :disabled="process.run"
                        outlined
                        :items="list.status"
                        item-text="label"
                        item-value="value"
                        v-model="filter.status"
                        v-on:change="getList()"
                        label="Status"
                        color="#0299B7"
                        hide-details
                      >
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>

                  <v-row class="mt-7 justify-end">
                    <v-col cols="12" md="4">
                      <v-text-field
                        :disabled="process.run"
                        outlined
                        dense
                        :hide-details="true"
                        placeholder="Cari . . ."
                        clearable
                        color="#0299B7"
                        class="mx-3"
                        v-model="form.cari"
                        @click:clear="
                          form.cari = '';
                          getList();
                        "
                        v-on:keyup.enter="getList()"
                        prepend-inner-icon="mdi-magnify"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-card-text
                    class="pa-5 px-0"
                    style="height: calc(100vh - 195px)"
                  >
                    <v-skeleton-loader
                      :loading="process.run"
                      transition="scale-transition"
                      :tile="false"
                      :style="process.run ? 'height: calc(100vh - 305px)' : ''"
                      type="table-tbody"
                    >
                      <div class="table-scroll-x">
                        <v-data-table
                          :headers="headers"
                          :items="row"
                          :items-per-page="10"
                          class="elevation-1 required table-scroll-x__table"
                        >
                          <template v-slot:[`item.harga_satuan`]="{ item }">
                            <td class="text-right">{{ item.harga_satuan }}</td>
                          </template>
                          <template v-slot:[`item.harga_internal`]="{ item }">
                            <td class="text-right">
                              {{ item.harga_internal }}
                            </td>
                          </template>
                          <template v-slot:[`item.harga_external`]="{ item }">
                            <td class="text-right">
                              {{ item.harga_external }}
                            </td>
                          </template>
                          <template v-slot:[`item.status`]="{ item }">
                            <td>
                              <span :class="getCatalogStatusClass(item.status)">
                                {{ item.status }}
                              </span>
                              <div
                                v-if="item.tanggal_penggunaan"
                                class="caption color-fourth mt-2"
                              >
                                {{ item.tanggal_penggunaan }}
                              </div>
                            </td>
                          </template>
                        </v-data-table>
                      </div>
                    </v-skeleton-loader>
                  </v-card-text>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { get } from "@/service/Axios";
import statusMixin from "@/mixin";
import Snackbar from "@/components/Snackbar.vue";
import LoadingComponent from "@/components/Loading.vue";

export default {
  mixins: [statusMixin],
  data() {
    return {
      form: {
        cari: ""
      },
      filter: {
        lab: "all",
        jenis: "all",
        status: "all"
      },
      process: {
        run: false,
        loading: false
      },
      list: {
        lab: [],
        jenis: [],
        status: [
          { label: "Semua", value: "all" },
          { label: "Tersedia", value: "1" },
          { label: "Tidak tersedia", value: "0" }
        ]
      },
      row: [],
      snackbar: false,
      text: "",
      timeout: 3000
    };
  },

  components: {
    Snackbar,
    LoadingComponent
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    roles() {
      return this.$store.state.roles;
    },
    isPendaftar() {
      return this.roles === "Pendaftar";
    },
    isInternalUser() {
      return Boolean(this.user.email && this.user.email.endsWith("uii.ac.id"));
    },
    useExternalPrice() {
      const externalProgramStudi = ["613", "616", "615", "939", "924"];
      const kdProgramStudi = String(
        this.user.kdProgramStudi || this.user.kd_program_studi || ""
      );
      return externalProgramStudi.includes(kdProgramStudi);
    },
    headers() {
      const baseHeaders = [
        { text: "No.", value: "no", sortable: false },
        { text: "Jenis", value: "jenis", sortable: false },
        { text: "Kode", value: "kode", sortable: false },
        { text: "Nama", value: "nama", sortable: false },
        { text: "Stok", value: "stok", sortable: false },
        { text: "Satuan", value: "satuan", sortable: false }
      ];

      const priceHeaders = this.isPendaftar
        ? [
            {
              text: "Harga satuan internal (Rp)",
              value: "harga_internal",
              align: "right",
              sortable: false
            },
            {
              text: "Harga satuan eksternal (Rp)",
              value: "harga_external",
              align: "right",
              sortable: false
            }
          ]
        : [
            {
              text: "Harga satuan (Rp)",
              value: "harga_satuan",
              align: "right",
              sortable: false
            }
          ];

      return [
        ...baseHeaders,
        ...priceHeaders,
        { text: "Laboratorium", value: "laboratorium", sortable: false },
        {
          text: "Status",
          value: "status",
          sortable: false,
          width: "160px"
        }
      ];
    }
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      this.process.run = true;
      this.process.loading = true;
      await Promise.all([this.getObjectType(), this.getLaboratory()]);
      this.process.loading = false;
      this.process.run = false;
      this.getList();
    },

    async getObjectType() {
      try {
        const response = await get("object-type");
        if (response.status === 200 && response.data.data) {
          const jenis = response.data.data.map((item) => ({
            id: item.id,
            kd_jenis_barang: item.kdJenisBarang,
            nama_jenis_barang: item.namaJenisBarang
          }));
          jenis.unshift({
            id: "all",
            kd_jenis_barang: "all",
            nama_jenis_barang: "Semua"
          });
          this.list.jenis = jenis;
          this.filter.jenis = jenis[0].id;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getLaboratory() {
      try {
        const params = {
          flag_lainnya: "1"
        };
        const { data, status } = await get("laboratory", { params });
        if (status === 200 && data.data) {
          const labList = data.data.map((lab) => ({
            id: lab.id,
            kd_laboratorium: lab.kdLaboratorium,
            nama_laboratorium: lab.namaLaboratorium
          }));
          labList.unshift({
            id: "all",
            kd_laboratorium: "all",
            nama_laboratorium: "Semua"
          });
          this.list.lab = labList;
          this.filter.lab = labList[0].id;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getList() {
      try {
        this.process.run = true;
        const params = {
          id_laboratorium: this.filter.lab,
          id_jenis_barang: this.filter.jenis,
          status: this.filter.status,
          search: this.form.cari
        };
        const { data, status } = await get("catalog", { params });
        if (status === 200 && data.data) {
          this.row = this.normalizeCatalogData(data.data).map((item, index) =>
            this.mapCatalogItem(item, index)
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.process.run = false;
      }
    },

    normalizeCatalogData(data) {
      if (Array.isArray(data)) {
        return data;
      }
      return [
        ...this.withJenis(data.alat || data.tools || [], "alat"),
        ...this.withJenis(data.bahan || data.items || [], "bahan"),
        ...this.withJenis(
          data.instrumen || data.instrument || data.instruments || [],
          "instrumen"
        )
      ];
    },

    withJenis(items, jenis) {
      return items.map((item) => ({
        ...item,
        jenis: item.jenis || jenis
      }));
    },

    mapCatalogItem(item, index) {
      const hargaInternal = this.getFirstValue(item, [
        "tarifInternal",
        "tarif_internal",
        "hargaInternal",
        "harga_internal",
        "hargaSatuanInternal",
        "harga_internal_satuan",
        "hargaInternalSatuan"
      ]);
      const hargaExternal = this.getFirstValue(item, [
        "tarifEksternal",
        "tarif_eksternal",
        "hargaEksternal",
        "harga_external",
        "hargaSatuanEksternal",
        "harga_eksternal_satuan",
        "hargaEksternalSatuan"
      ]);

      return {
        no: index + 1,
        jenis: this.formatJenis(
          this.getFirstValue(item, [
            "namaJenisBarang",
            "nama_jenis_barang",
            "jenis",
            "type",
            "kategori"
          ])
        ),
        kode: this.getFirstValue(item, [
          "kode",
          "kdAlat",
          "kdBahan",
          "kdInstrumen"
        ]),
        nama: this.getFirstValue(item, [
          "nama",
          "namaAlat",
          "namaBahan",
          "namaInstrumen"
        ]),
        stok: this.formatEmpty(
          this.getFirstValue(item, ["stok", "jmlStok", "jumlahStok"])
        ),
        satuan: this.formatEmpty(this.getSatuan(item)),
        harga_satuan: this.formatPrice(
          this.useExternalPrice ? hargaExternal : hargaInternal
        ),
        harga_internal: this.formatPrice(hargaInternal),
        harga_external: this.formatPrice(hargaExternal),
        laboratorium: this.formatEmpty(this.getLaboratorium(item)),
        status: this.getStatusText(item),
        tanggal_penggunaan: this.getTanggalPenggunaan(item)
      };
    },

    getFirstValue(item, keys) {
      const value = keys
        .map((key) => item[key])
        .find((val) => {
          return val !== undefined && val !== null && val !== "";
        });
      return value !== undefined ? value : "-";
    },

    getSatuan(item) {
      if (item.satuan === "formula") {
        return item.satuan;
      }
      if (item.durasi && item.satuan) {
        return `${item.durasi} ${item.satuan}`;
      }
      return this.getFirstValue(item, ["satuan", "namaSatuan"]);
    },

    getLaboratorium(item) {
      return (
        item.laboratorium ||
        item.lab?.namaLaboratorium ||
        item.laboratory?.namaLaboratorium ||
        item.namaLaboratorium
      );
    },

    getStatusText(item) {
      if (item.flagTersedia === 1 || item.flagTersedia === true) {
        return "Tersedia";
      }
      if (item.flagTersedia === 0 || item.flagTersedia === false) {
        return "Tidak tersedia";
      }
      const status = this.getFirstValue(item, ["status", "statusPenggunaan"]);
      if (status !== "-") {
        return status;
      }
      if (
        item.flagDigunakan === 1 ||
        item.flagDigunakan === true ||
        item.digunakan === true
      ) {
        return "Digunakan";
      }
      if (item.flagDigunakan === 0 || item.flagDigunakan === false) {
        return "Tidak digunakan";
      }
      if (item.flagAktif === 0) {
        return "Tidak aktif";
      }
      return "Aktif";
    },

    getCatalogStatusClass(status) {
      if (status === "Digunakan" || status === "Tidak tersedia") {
        return "status-ditolak";
      }
      if (status === "Tidak digunakan" || status === "Tersedia") {
        return "status-pembayaran-terverifikasi";
      }
      return this.getStatusClass(status);
    },

    getTanggalPenggunaan(item) {
      const mulai = this.getFirstValue(item, [
        "tglMulai",
        "tglMulaiPenggunaan",
        "tanggalMulai",
        "tanggalMulaiPenggunaan"
      ]);
      const selesai = this.getFirstValue(item, [
        "tglSelesai",
        "tglSelesaiPenggunaan",
        "tanggalSelesai",
        "tanggalSelesaiPenggunaan"
      ]);

      if (mulai === "-" && selesai === "-") {
        return "";
      }
      if (mulai !== "-" && selesai !== "-") {
        return `${this.$callbackdate(mulai)} - ${this.$callbackdate(selesai)}`;
      }
      return this.$callbackdate(mulai !== "-" ? mulai : selesai);
    },

    formatJenis(jenis) {
      if (jenis === "-") {
        return "-";
      }
      const value = String(jenis).toLowerCase();
      if (value === "tool" || value === "alat") {
        return "Alat";
      }
      if (value === "item" || value === "bahan") {
        return "Bahan";
      }
      if (value === "instrument" || value === "instrumen") {
        return "Instrumen";
      }
      return jenis;
    },

    formatPrice(value) {
      if (
        value === undefined ||
        value === null ||
        value === "" ||
        value === "-"
      ) {
        return "-";
      }
      return this.$options.filters.price(value);
    },

    formatEmpty(value) {
      return value === undefined || value === null || value === ""
        ? "-"
        : value;
    }
  }
};
</script>

<style scoped>
.table-scroll-x {
  overflow-x: auto;
  width: 100%;
}

.table-scroll-x__table {
  min-width: 100%;
  width: 100%;
  max-width: 100%;
}
</style>
